{
    "generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "notFound": "Wir konnten nicht finden, wonach Sie gesucht haben."
}
